var map = {
	"./template_1.jpg": "dx6X",
	"./template_2.jpg": "3RWg",
	"./template_3.png": "ZNiN",
	"./template_4.png": "/raX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VI1W";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template ^\.\/.*$
// module id = VI1W
// module chunks = 92